import MoreFeatures from './MoreFeatures'

export default class EnterprisePlan extends React.PureComponent

  render: ->
    <div className="card plan-card enterprise-plan outline-on-hover">
      <div className="card-body gradient-background">
        { @renderTitle()     }
        { @renderPrice()     }
        { @renderCtaButton() }

        <hr/>

        <h4>
          {@props.i18n.dataPrivacy}
        </h4>
        <ul>
          <li>
            <i className="far fa-circle-check" />
            <span dangerouslySetInnerHTML={{ __html: @props.i18n.fullPrivacy }} />
          </li>
        </ul>

        <hr/>

        <h4>
          {@props.i18n.enterpriseFeatures}
        </h4>
        <ul>
          <li>
            <i className="far fa-circle-check" />
            <span dangerouslySetInnerHTML={{ __html: @props.i18n.euOnlyModels }} />
          </li>
          <li>
            <i className="far fa-circle-check" />
            <span dangerouslySetInnerHTML={{ __html: @props.i18n.multipleUsers }} />
          </li>
          <li>
            <i className="far fa-circle-check" />
            <span dangerouslySetInnerHTML={{ __html: @props.i18n.whiteLabel }} />
          </li>
          <li>
            <i className="far fa-circle-check" />
            <span dangerouslySetInnerHTML={{ __html: @props.i18n.higherCustomization }} />
          </li>
          <li>
            <i className="far fa-circle-check" />
            <span dangerouslySetInnerHTML={{ __html: @props.i18n.onPremises }} />
          </li>
        </ul>

        <hr/>

        <div className="same-as-pro">
          + {@props.i18n.sameAsPro}
        </div>

        <div className="flex-grow-1" />

        <MoreFeatures visible={@props.moreFeaturesVisible}
                      toggle={@props.toggleMoreFeatures}
                      i18n={@props.i18n.moreFeatures} />
      </div>
    </div>

  renderTitle: ->
    <h3>
      {@props.i18n.title}
    </h3>

  renderPrice: ->
    <div className="price big no-amount">
      {@props.i18n.price}
    </div>

  renderCtaButton: ->
    <a className="btn btn-outline-primary"
       target="_blank"
       href="mailto:contact@neurooo.com">
      {@props.i18n.ctaButton.contactUs}
    </a>
